import {Component, Input} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-prompt-modal',
    templateUrl: './prompt-modal.component.html',
    styleUrls: ['./prompt-modal.component.scss'],
    standalone: false
})
export class PromptModalComponent {

  @Input() mode = "delete";
  @Input() itemName = "";
  @Input() title = "";
  @Input() confirmButton = "";
  @Input() body = "";
  @Input() hideDeleteAssociatedItem = false;
  @Input() inputLabel = "Request details";
  @Input() inputPlaceholder = "Add details";
  @Input() requireInput = false;

  inputValue = "";
  showInputError = false;

  constructor(public activeModal: NgbActiveModal) { }

  confirm() {
    if (this.mode === 'request_changes') {
      const value = (this.inputValue || '').trim();
      if (this.requireInput && !value) {
        this.showInputError = true;
        return;
      }

      this.activeModal.close({
        confirmed: true,
        value
      });
      return;
    }

    this.activeModal.close('Ok click');
  }
}
